import { FC } from 'react';
import EfImg from 'elem/ui/ef-img';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

const Banner: FC = () => {
    const { t } = useLang('tradein');

    return (
        <div className={styled.Banner}>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1723448196383/pc_kv.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1723448215174/m_kv.jpg"
            />
            <div className="ef-container banner-context">
                <h5 className="title">{t('banner_title')}</h5>
                <p className="desc">{t('banner_desc')}</p>
            </div>
        </div>
    );
};

export default Banner;
